// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_row__t\\+Ig6 {
    position: relative;
    padding: 24px var(--padding-x) 24px calc(42px + var(--padding-x));
}

.styles_row__t\\+Ig6:not(:last-child) {
    border-bottom: 1px dashed var(--light-grey);
    /*padding: 24px 0;*/
}

.styles_row__t\\+Ig6:not(.styles_disabled__PcLyZ) header {
    cursor: pointer;
}

.styles_header__t4GO\\+ {
    display: flex;
    grid-gap: 26px;
    /*overflow: hidden;*/
    /*transition: max-height 0.4s;*/
    max-height: max-content;
    /*padding-left: 30px;*/
    max-height: 100px;
    overflow: hidden;
}

.styles_contentOuter__Ml3LF {
    overflow: hidden;
    /*transition: max-height 0.4s;*/
    max-height: 0;
    padding-right: 46px;
}

/*.content {*/
/*    padding-top: 12px;*/
/*}*/

.styles_grid__98nZ- {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 0px;
    grid-column-gap: 40px;
    align-items: flex-start;
}

.styles_toggle__7NZia {
    position: absolute;
    top: 24px;
    left: var(--padding-x);
    color: #7b848e;
    transition: transform 0.4s;
    padding: 2px 6px;
    transform: rotate(-90deg);
}

.styles_row__t\\+Ig6.styles_disabled__PcLyZ .styles_toggle__7NZia {
    color: var(--light-grey);
}

.styles_row__t\\+Ig6.styles_disabled__PcLyZ {
    border-color: var(--primary-color);
}

.styles_open__N51fZ .styles_toggle__7NZia {
    color: var(--primary-color-active);
}

.styles_open__N51fZ .styles_contentOuter__Ml3LF {
    max-height: max-content;
}

.styles_open__N51fZ .styles_header__t4GO\\+.styles_hide__FTKcF {
    max-height: 0;
}

.styles_open__N51fZ .styles_toggle__7NZia {
    transform: rotate(0);
    /*top: 36px;*/
}

.styles_open__N51fZ .styles_toggle__7NZia.styles_offset__UN\\+TF {
    top: 36px;
}

.styles_open__N51fZ .styles_content__pAjtm {
    padding-top: 0;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_toggle__7NZia {
        width: 28px;
    }

    .styles_row__t\\+Ig6:not(:last-child),
    .styles_row__t\\+Ig6 {
        padding: 20px var(--padding-x) 20px calc(30px + var(--padding-x));
    }

    .styles_toggle__7NZia {
        top: 18px;
    }

    .styles_open__N51fZ .styles_toggle__7NZia.styles_offset__UN\\+TF {
        top: 26px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Storage/layout/FormCollapsableRow/styles.module.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,iEAAiE;AACrE;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,+BAA+B;IAC/B,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;AACvB;;AAEA,aAAa;AACb,yBAAyB;AACzB,IAAI;;AAEJ;IACI,aAAa;IACb,qCAAqC;IACrC,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;;QAEI,iEAAiE;IACrE;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;AACJ","sourcesContent":["@value screen-md-max, screen-lg-min from '../../../../breakpoints.css';\n\n.row {\n    position: relative;\n    padding: 24px var(--padding-x) 24px calc(42px + var(--padding-x));\n}\n\n.row:not(:last-child) {\n    border-bottom: 1px dashed var(--light-grey);\n    /*padding: 24px 0;*/\n}\n\n.row:not(.disabled) header {\n    cursor: pointer;\n}\n\n.header {\n    display: flex;\n    grid-gap: 26px;\n    /*overflow: hidden;*/\n    /*transition: max-height 0.4s;*/\n    max-height: max-content;\n    /*padding-left: 30px;*/\n    max-height: 100px;\n    overflow: hidden;\n}\n\n.contentOuter {\n    overflow: hidden;\n    /*transition: max-height 0.4s;*/\n    max-height: 0;\n    padding-right: 46px;\n}\n\n/*.content {*/\n/*    padding-top: 12px;*/\n/*}*/\n\n.grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-row-gap: 0px;\n    grid-column-gap: 40px;\n    align-items: flex-start;\n}\n\n.toggle {\n    position: absolute;\n    top: 24px;\n    left: var(--padding-x);\n    color: #7b848e;\n    transition: transform 0.4s;\n    padding: 2px 6px;\n    transform: rotate(-90deg);\n}\n\n.row.disabled .toggle {\n    color: var(--light-grey);\n}\n\n.row.disabled {\n    border-color: var(--primary-color);\n}\n\n.open .toggle {\n    color: var(--primary-color-active);\n}\n\n.open .contentOuter {\n    max-height: max-content;\n}\n\n.open .header.hide {\n    max-height: 0;\n}\n\n.open .toggle {\n    transform: rotate(0);\n    /*top: 36px;*/\n}\n\n.open .toggle.offset {\n    top: 36px;\n}\n\n.open .content {\n    padding-top: 0;\n}\n\n@media screen-md-max {\n    .toggle {\n        width: 28px;\n    }\n\n    .row:not(:last-child),\n    .row {\n        padding: 20px var(--padding-x) 20px calc(30px + var(--padding-x));\n    }\n\n    .toggle {\n        top: 18px;\n    }\n\n    .open .toggle.offset {\n        top: 26px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"row": `styles_row__t+Ig6`,
	"disabled": `styles_disabled__PcLyZ`,
	"header": `styles_header__t4GO+`,
	"contentOuter": `styles_contentOuter__Ml3LF`,
	"grid": `styles_grid__98nZ-`,
	"toggle": `styles_toggle__7NZia`,
	"open": `styles_open__N51fZ`,
	"hide": `styles_hide__FTKcF`,
	"offset": `styles_offset__UN+TF`,
	"content": `styles_content__pAjtm`
};
export default ___CSS_LOADER_EXPORT___;
